import { AbstractReportPmsApiService } from '../abstract-report.service';
import { AverageDailyRate } from '../../../models/reports/production/average-daily-rate.model';

/**
 * @class AverageDailyRatePmsApiService
 * @extends {AbstractReportPmsApiService<ReservationByRatePlan>}
 */
export class AverageDailyRatePmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/production/average-daily-rate';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {AverageDailyRate}
     * @protected
     */
    newModel(attributes, ...params) {

        return new AverageDailyRate(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<AverageDailyRate[]>}
     */
    getGraphData(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/production/average-daily-rate.service.js